import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import moment from 'moment';
import axios from 'axios';
export default {
  data() {
    return {
      data: [],
      customerList: [],
      record: null,
      palyVisiable: false,
      defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `共 ${total} 条`;
        }
      }
    };
  },
  methods: {
    openChangeDate(status) {
      if (status) {
        this.form.startRecordTime = [];
      }
    },
    onChangeTime(date) {
      if (date.length) {
        let startIsToday = moment(this.form.startRecordTime[0]).isSame(moment(), 'days') && moment(this.form.startRecordTime[0]).isAfter(moment());
        let endIsToday = moment(this.form.startRecordTime[1]).isSame(moment(), 'days') && moment(this.form.startRecordTime[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.form.startRecordTime[0] = moment();
            this.form.startRecordTime[1] = moment();
          } else if (endIsToday) {
            this.form.startRecordTime[1] = moment();
          }
        }
      }
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    range(start, end) {
      const result = [];
      for (let i = start; i <= end; i++) {
        result.push(i);
      }
      return result;
    },
    disabledTime(date, type) {
      if (type === 'end' && date && date.length) {
        let endYear = moment(date[1]).year();
        let endMonth = moment(date[1]).month();
        let endDay = moment(date[1]).day();
        let currentYear = moment().year();
        let currentMonth = moment().month();
        let currentDay = moment().day();
        let currentHours = moment().hours();
        let currentMinutes = moment().minutes();
        let currentSeconds = moment().seconds();
        if (endYear === currentYear && endMonth === currentMonth && endDay === currentDay) {
          return {
            disabledHours: () => this.range(currentHours + 1, 24),
            disabledMinutes: () => this.range(currentMinutes + 1, 60),
            disabledSeconds: () => this.range(currentSeconds + 1, 60)
          };
        }
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => []
      };
    },
    filterOption2(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.searchFun();
    },
    playVideo(record) {
      this.record = record;
      this.palyVisiable = true;
    },
    closeModeal() {
      this.palyVisiable = false;
    },
    downVideo(record) {
      if (!record.url) return;
      let url = process.env.VUE_APP_File + record.url;
      axios(url, {
        method: 'get',
        responseType: 'blob'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        let filename = record.url.split('/').pop();
        const link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('download', filename);
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      });
    }
  }
};